import { ID_BUNDLE_PACK_COPY_TO_ID_ORIGINAL } from 'src/entities/bundles/model/consts';

/**
 * Returns the id of the original pack add-on a copy was made from,
 * or the id itself for any other add-on.
 * @param idBundle - The add-on id.
 */
export const getIdBundleBase = (idBundle: string): string => (
  ID_BUNDLE_PACK_COPY_TO_ID_ORIGINAL[idBundle] ?? idBundle
);
